import { ChainID, EBlockchainFeature } from '@ankr.com/chains-list';

import { ChainGroupID, EndpointGroup } from 'modules/endpoints/types';
import { ChainIdParams, getChainId } from 'modules/chains/utils/getChainId';

import {
  ChainCallProtocol,
  Consensus,
} from '../components/ChainSelectorsProvider';

export interface StatsChainIdParams extends ChainIdParams {
  chainCallProtocol?: ChainCallProtocol;
  consensus?: Consensus;
  isConsensusEnabled?: boolean;
}

const getChainIDByConsensus = (group: EndpointGroup, consensus?: Consensus) => {
  if (consensus === 'beacon') {
    return group.beacons?.[0].chains?.[0].id;
  }

  if (consensus === 'opnode') {
    return group.opnodes?.[0].chains?.[0].id;
  }

  return undefined;
};

const getGRPCChainID = (group: EndpointGroup) =>
  group.chains.find(chain => chain.features.includes(EBlockchainFeature.GRPC))
    ?.id;

export const getStatsChainID = ({
  chainCallProtocol,
  chainSubType,
  chainType,
  consensus,
  group,
  isConsensusEnabled,
  publicChain,
}: StatsChainIdParams) => {
  // the vRPC group is not in getChainGroups, so getChainId would drop the filter
  if (group.id === ChainGroupID.VRPC) {
    return group.chains[0]?.id;
  }

  const keepEVMChainID =
    publicChain.id === ChainID.ZETACHAIN ||
    publicChain.id === ChainID.HORIZEN ||
    publicChain.id === ChainID.BERACHAIN ||
    publicChain.id === ChainID.TAC ||
    publicChain.id === ChainID.KAVA ||
    publicChain.id === ChainID.IOTA_EVM ||
    publicChain.id === ChainID.ZERO_G ||
    publicChain.id === ChainID.SEI;

  const withExceptions =
    publicChain.id === ChainID.HORIZEN || publicChain.id === ChainID.TENET;

  const chainId = getChainId({
    chainType,
    chainSubType,
    group,
    keepEVMChainID,
    publicChain,
    withExceptions,
  });

  if (chainCallProtocol === 'grpc') {
    return getGRPCChainID(group) || chainId;
  }

  if (isConsensusEnabled) {
    return getChainIDByConsensus(group, consensus) || chainId;
  }

  return chainId;
};
